import axios from "../api";
const isCompleteTopPlayer = (topPlayer) => Boolean(topPlayer?.basePlayer && topPlayer?.evolutionPlayer);
/**
 * Guarantees the array exists and that every pair is whole. Shared with every
 * route that embeds an evolution in the `GET /evolutions` shape (Home's drops).
 */
export const normalizeEvolution = (evo, onContractViolation) => {
    const received = evo.topPlayers ?? [];
    const topPlayers = received.filter(isCompleteTopPlayer);
    if (topPlayers.length !== received.length) {
        onContractViolation?.("evolutions.topPlayers", "topPlayers entry missing basePlayer or evolutionPlayer", {
            evolutionId: evo.id,
            evolutionName: evo.name,
            received: received.length,
            kept: topPlayers.length,
        });
    }
    return { ...evo, topPlayers };
};
export const getEvolutions = async (onContractViolation) => {
    const res = await axios.get("/evolutions");
    const normalize = (evo) => normalizeEvolution(evo, onContractViolation);
    const evolutions = res.data.evolutions.map(normalize);
    const expiredEvolutions = res.data.expiredEvolutions.map(normalize);
    // An evolution can point at a category the backend never sent. Fill the gap
    // with a placeholder so nothing downstream dereferences an undefined category.
    const categories = [...res.data.categories];
    const knownIds = new Set(categories.map((c) => c.id));
    for (const evo of [...evolutions, ...expiredEvolutions]) {
        if (knownIds.has(evo.categoryId))
            continue;
        knownIds.add(evo.categoryId);
        categories.push({
            id: evo.categoryId,
            name: `Category ${evo.categoryId}`,
            priority: 0,
        });
        onContractViolation?.("evolutions.categories", "evolution references a category missing from the response", { evolutionId: evo.id, categoryId: evo.categoryId });
    }
    return { evolutions, expiredEvolutions, categories };
};
//# sourceMappingURL=getEvolutions.js.map